export type PaymentAccount = 'AMIN' | 'HUVUDKONTO' | 'CENTRAL_RESERVE'

export const PAYMENT_ACCOUNT_LABELS: Record<PaymentAccount, string> = {
  AMIN: 'Amin',
  HUVUDKONTO: 'Huvudkonto',
  CENTRAL_RESERVE: 'Central Reserve',
}

export type VoucherType = {
  id: string
  department: Department
  state: string
  created_at: number
  submitted_at: string | number | null
  total_amount: number
  payment_account: PaymentAccount | null
  currency: string
  invoice_currency: string
  receivers_account_number: string
  description: string
  reference_number: number | null
  expense_period?: number | null
  paid_by_amin?: string | number | null
  claimed_by: User
  pay_to: string
  created_by: User
  financial_year: FinancialYear
  payment_reference: string
  voucher_cost_category: VoucherCostCategory[]
  voucher_approvals: VoucherApproval[]
  workflow?: Workflow | null
  branch: string
  comments?: Comment[]
  tags?: Tag[]
}

export type Tag = {
  id: number
  name: string
  voucher_count?: number
  can_manage?: boolean
}

export type MyVoucherRow = VoucherType & {
  is_created_by_me: boolean
  my_action: 'APPROVED' | 'REJECTED' | 'PAID' | null
}

export type FinancialYear = {
  id: number
  year: string
  start_date: string
  end_date: string
}

export type Workflow = {
  id: number
  name: string
  active: boolean
  approval_stage: ApprovalStage[]
}

export type VoucherApproval = {
  id: number
  voucher_id: string
  approved_at: string | null
  status: string
  comment: string | null
  order_number: number
  approver: User
  approval_stage: ApprovalStage
}

export type ApprovalStage = {
  id: number
  is_payment_stage: boolean
  order_number: number
}

export type Role = {
  id: number
  name: string
  scope: string
  description: string
}

export type Approver = {
  status: boolean
  user: User
}

export type VoucherCostCategory = {
  id?: number
  sub_cost_category: SubCostCategory
  cost_share: number
  receipts?: VoucherReceipt[]
  comment?: string
}

export type CostCategory = {
  id: string
  name: string
  code: string
  sub_cost_categories: SubCostCategory[]
}

export type SubCostCategory = {
  id: string
  name: string
  code: string
  cost_category?: CostCategory
}

export type VoucherReceipt = {
  id: string
  path: string
  voucherId?: string
}

export type User = {
  id: string
  first_name: string
  last_name: string
  email: string
  branch?: string
  user_role?: Role
  department?: Department
}

export type Department = {
  id: string
  name: string
  national_only: boolean
}

export type Comment = {
  id: string
  comment: string
  created_at: string
  updated_at: string
  user: User
}

export enum VoucherApprovalStageStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PAID = 'PAID',
}

export enum Branch {
  GOTEBORG = 'GOTEBORG',
  KALMAR = 'KALMAR',
  LULEA = 'LULEA',
  MALMO = 'MALMO',
  STOCKHOLM = 'STOCKHOLM',
  NATIONAL = 'NATIONAL',
}

export enum VoucherState {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  IN_PROGRESS = 'IN_PROGRESS',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
}

export const Roles = {
  NATIONAL: {
    AMIR: { id: 1, name: 'Amir' },
    AMIN: { id: 3, name: 'Amin' },
    MAAL: { id: 5, name: 'Maal' },
    MISSIONARY: { id: 7, name: 'Missionary' },
    SECRETARY: { id: 10, name: 'Secretary' },
    ADMIN: { id: 11, name: 'Admin' },
    OTHER: { id: 12, name: 'Other' },
  },
  BRANCH: {
    AMIN: { id: 2, name: 'Amin' },
    MAAL: { id: 4, name: 'Maal' },
    MISSIONARY: { id: 6, name: 'Missionary' },
    SADR: { id: 8, name: 'Sadr' },
    SECRETARY: { id: 9, name: 'Secretary' },
  },
} as const
